import { RouteObject } from "react-router-dom";
import {
  MODULE_SETTINGS_PATH,
  ModuleSettingsPage,
} from "@/modules/global-wizard/pages/module-settings";
import { NavigationItem } from "@/modules/common/features/navigation/model/types";
import { ApartmentOutlined } from "@ant-design/icons";
import { HR } from "@/shared/modules/constants/modules-id";

export const modulesSettings: RouteObject[] = [
  {
    path: MODULE_SETTINGS_PATH,
    element: <ModuleSettingsPage />,
  },
];

export const globalWizardMenuItems: NavigationItem[] = [
  {
    label: "module settings",
    icon: <ApartmentOutlined />,
    to: MODULE_SETTINGS_PATH,
    requiredModule: HR,
  },
];
